import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ allowedRoles }) => {
    const token = localStorage.getItem("token");
    const role = Number(localStorage.getItem("role")); // Convert role to number

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    if (!allowedRoles.includes(role)) {
        return <Navigate to="/dashboard" replace />; // Redirect unauthorized users
    }

    return <Outlet />; // Allows rendering nested routes
};

export default ProtectedRoute;

